import { type ConversationAction, PROMPT_OF_DAY_ACTION_ID } from '../../types';

export const orderRankedActions = (
	actionRankingOrder: string[],
	actions: ConversationAction[],
): ConversationAction[] => {
	const remainingActions = [...actions];

	const rerankedActions = actionRankingOrder
		.map((rankedActionType) => {
			const actionIndex = remainingActions.findIndex((action) => action.id === rankedActionType);
			if (actionIndex !== -1) {
				const [foundAction] = remainingActions.splice(actionIndex, 1);
				return foundAction;
			}
			return null;
		})
		.filter(Boolean) as ConversationAction[];

	// Handle 'prompt-of-the-day' action placement when not already re-ranked
	const promptOfTheDayIndex = remainingActions.findIndex(
		(action) => action.id === PROMPT_OF_DAY_ACTION_ID,
	);
	const convoStarterIndex = rerankedActions.findIndex((action) => action.id === 'convo-starter');

	if (promptOfTheDayIndex !== -1) {
		const [promptOfTheDayAction] = remainingActions.splice(promptOfTheDayIndex, 1);

		if (convoStarterIndex !== -1) {
			// Replace 'convo-starter' with 'prompt-of-the-day' at the same position and push 'convo-starter' to bottom
			const [convoStarterAction] = rerankedActions.splice(
				convoStarterIndex,
				1,
				promptOfTheDayAction,
			);
			rerankedActions.push(convoStarterAction);
		} else {
			// Just add 'prompt-of-the-day' to the bottom
			rerankedActions.push(promptOfTheDayAction);
		}
	}

	return [...rerankedActions, ...remainingActions];
};
